// components/ErrorFallback.tsx
import { Card, Typography, Button, Space } from 'antd';
import { FrownOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

const { Title, Text } = Typography;

type ErrorFallbackProps = {
  message?: string;
  backHref?: string;
};

export default function ErrorFallback(props: ErrorFallbackProps) {
  const history = useHistory();

  return (
    <div className="modal-loading-overlay">
      <Card
        style={{ maxWidth: 400, width: '100%', textAlign: 'center' }}
        bordered
      >
        <FrownOutlined style={{ fontSize: 48, color: '#ff4d4f' }} />

        <Title level={3}>Algo deu errado</Title>

        <Text type="secondary">
          {props?.message ??
            'Ops! Não conseguimos carregar os dados no momento. Tente novamente em instantes e, se o problema continuar, fale com o suporte.'}
        </Text>

        <Space style={{ marginTop: 16 }}>
          <Button
            onClick={() =>
              props?.backHref ? history.push(props.backHref) : history.goBack()
            }
          >
            Voltar
          </Button>

          <Button type="primary" onClick={() => window.location.reload()}>
            Tentar novamente
          </Button>
        </Space>
      </Card>
    </div>
  );
}
